import { ErrorMessage } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";
import { Form, Spinner } from "react-bootstrap";
import { B2Form, B2Switch } from "@hdb/biome-2";

export const renderControlGroup = (
  control: any,
  name: any,
  value: any,
  isSecurityMonitoring: any,
  handleChange: any,
  touched: any,
  errors: any,

  setSelections: any,
  setFieldValue: any,
  typeaheadRef: any,
  selections: any,
) => {
  switch (control.type) {
    case "text":
      return (
        <div className="flex items-start w-100">
          <div className="w-100">
            <div className="filter-label mb-2">{control.label}</div>
            <Form.Group>
              <Form.Control
                type="text"
                placeholder={control.placeholder}
                name={name}
                onChange={handleChange}
                value={value}
                required={control.required ?? false}
                readOnly={control.readOnly ?? false}
                disabled={control.disabled ?? false}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );
    case "switch":
      return (
        <div
          className={`flex flex-column mt-3 mb-3 ${
            control.hasOwnProperty("display") && !control.display
              ? "d-none"
              : ""
          }`}
        >
          <div className="mb-2">
            {control.label}
            {control.required && <span className="text-danger">*</span>}
          </div>
          <div className="">
            <B2Form.Group>
              <B2Switch
                type="switch"
                name={control.name}
                disabled={control?.disabled ? control?.disabled : false}
                readOnly={control?.readOnly ? control?.readOnly : false}
                onChange={(e: any) => {
                  //  ;
                  handleChange(e);
                  setFieldValue(control?.name, e.target.checked);
                }}
                value={value}
                checked={value}
                defaultChecked={value}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </B2Form.Group>
          </div>
        </div>
      );
    case "email":
      return (
        <div className="flex items-start  w-100">
          <div className="w-100">
            <div className="filter-label">{control.label}</div>
            <Form.Group>
              <Form.Control
                type="email"
                placeholder={control.placeholder}
                name={name}
                onChange={handleChange}
                value={value}
                required={control.required ?? false}
                readOnly={control.readOnly ?? false}
                disabled={control.disabled ?? false}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );
    case "password":
      return (
        <div className="flex items-start  w-100">
          <div className="w-100">
            <div className="filter-label">{control.label}</div>
            <Form.Group>
              <Form.Control
                type="password"
                placeholder={control.placeholder}
                name={name}
                onChange={handleChange}
                value={value}
                required={control.required ?? false}
                readOnly={control.readOnly ?? false}
                disabled={control.disabled ?? false}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );
    case "tel":
      return (
        <div className="flex items-start w-100">
          <div className="w-100">
            <div className="filter-label mb-2">{control.label}</div>
            <Form.Group>
              {control.prefix && (
                <div className="input-group">
                  <span className="input-group-text">{control.prefix}</span>
                  <Form.Control
                    type="tel"
                    placeholder={control.placeholder}
                    name={name}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      // Allow: backspace, delete, tab, escape, enter, arrow keys
                      if (
                        [
                          "Backspace",
                          "Delete",
                          "Tab",
                          "Escape",
                          "Enter",
                          "ArrowLeft",
                          "ArrowRight",
                          "ArrowUp",
                          "ArrowDown",
                          "Home",
                          "End",
                        ].includes(e.key) ||
                        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                        (e.key === "a" && e.ctrlKey) ||
                        (e.key === "c" && e.ctrlKey) ||
                        (e.key === "v" && e.ctrlKey) ||
                        (e.key === "x" && e.ctrlKey)
                      ) {
                        return;
                      }
                      // Ensure that it is a number and stop the keypress
                      if (!/\d/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      // Strip spaces from pasted text, then check for non-digits
                      const pastedText = e.clipboardData.getData("text");
                      const stripped = pastedText.replace(/\s/g, "");
                      if (/^\d*$/.test(stripped)) {
                        const input = e.target as HTMLInputElement;
                        const start =
                          input.selectionStart ?? input.value.length;
                        const end = input.selectionEnd ?? input.value.length;
                        const newValue =
                          input.value.slice(0, start) +
                          stripped +
                          input.value.slice(end);
                        const truncated = control.maxLength
                          ? newValue.slice(0, control.maxLength)
                          : newValue;
                        const newCursorPos = Math.min(
                          start + stripped.length,
                          truncated.length,
                        );
                        setFieldValue(name, truncated);
                        requestAnimationFrame(() => {
                          input.selectionStart = newCursorPos;
                          input.selectionEnd = newCursorPos;
                        });
                      }
                    }}
                    value={value}
                    maxLength={control.maxLength}
                    pattern={control.pattern}
                    required={control.required ?? false}
                    readOnly={control.readOnly ?? false}
                    disabled={control.disabled ?? false}
                    isValid={touched[control.name] && !errors[control.name]}
                    isInvalid={
                      (!!touched[control.name] && !!errors[control.name]) ??
                      false
                    }
                  />
                </div>
              )}
              {!control.prefix && (
                <Form.Control
                  type="tel"
                  placeholder={control.placeholder}
                  name={name}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    // Allow: backspace, delete, tab, escape, enter, arrow keys
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "Tab",
                        "Escape",
                        "Enter",
                        "ArrowLeft",
                        "ArrowRight",
                        "ArrowUp",
                        "ArrowDown",
                        "Home",
                        "End",
                      ].includes(e.key) ||
                      // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                      (e.key === "a" && e.ctrlKey) ||
                      (e.key === "c" && e.ctrlKey) ||
                      (e.key === "v" && e.ctrlKey) ||
                      (e.key === "x" && e.ctrlKey)
                    ) {
                      return;
                    }
                    // Ensure that it is a number and stop the keypress
                    if (!/\d/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    // Strip spaces from pasted text, then check for non-digits
                    const pastedText = e.clipboardData.getData("text");
                    const stripped = pastedText.replace(/\s/g, "");
                    if (/^\d*$/.test(stripped)) {
                      const input = e.target as HTMLInputElement;
                      const start = input.selectionStart ?? input.value.length;
                      const end = input.selectionEnd ?? input.value.length;
                      const newValue =
                        input.value.slice(0, start) +
                        stripped +
                        input.value.slice(end);
                      const truncated = control.maxLength
                        ? newValue.slice(0, control.maxLength)
                        : newValue;
                      const newCursorPos = Math.min(
                        start + stripped.length,
                        truncated.length,
                      );
                      setFieldValue(name, truncated);
                      requestAnimationFrame(() => {
                        input.selectionStart = newCursorPos;
                        input.selectionEnd = newCursorPos;
                      });
                    }
                  }}
                  value={value}
                  maxLength={control.maxLength}
                  pattern={control.pattern}
                  required={control.required ?? false}
                  readOnly={control.readOnly ?? false}
                  disabled={control.disabled ?? false}
                  isValid={touched[control.name] && !errors[control.name]}
                  isInvalid={
                    (!!touched[control.name] && !!errors[control.name]) ?? false
                  }
                />
              )}
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );
    case "number":
      return (
        <div className="flex items-start w-100">
          <div className="w-100">
            <div
              className={`filter-label ${isSecurityMonitoring ? "mb-2" : ""}`}
            >
              {control.label}
            </div>
            <Form.Group>
              <Form.Control
                type="number"
                placeholder={control.placeholder}
                name={name}
                onChange={(event) => {
                  handleChange(event);
                }}
                value={value}
                required={control.required ?? false}
                readOnly={control.readOnly ?? false}
                disabled={control.disabled ?? false}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );
    case "textarea":
      return (
        <div className="flex items-start  w-100">
          <div className="w-100">
            <div className="filter-label">{control.label}</div>
            <Form.Group>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder={control.placeholder}
                name={name}
                onChange={handleChange}
                value={value}
                required={control.required ?? false}
                readOnly={control.readOnly ?? false}
                disabled={control.disabled ?? false}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );
    case "date":
      return (
        <div className="flex items-start  w-100">
          <div className="w-100">
            <div className="filter-label">{control.label}</div>
            <Form.Group>
              <Form.Control
                type="date"
                placeholder={control.placeholder}
                name={name}
                // onChange={handleChange}
                onChange={(event) => {
                  handleChange(event);

                  if (control.onChange) {
                    control.onChange(event.target.value);
                  }
                }}
                value={value}
                max={control.maxDate || ""}
                required={control.required ?? false}
                readOnly={control.readOnly ?? false}
                disabled={control.disabled ?? false}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />

              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );
    case "datetime":
      return (
        <div className="flex items-start  w-100">
          <div className="w-100">
            <div
              className={`filter-label ${isSecurityMonitoring ? "mb-2" : ""}`}
            >
              {control.label}
            </div>
            <Form.Group>
              <Form.Control
                type="datetime-local"
                placeholder={control.placeholder}
                name={name}
                onChange={handleChange}
                value={value}
                required={control.required ?? false}
                readOnly={control.readOnly ?? false}
                disabled={control.disabled ?? false}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );
    case "time":
      return (
        <div className="flex items-start  w-100">
          <div className="w-100">
            <div
              className={`filter-label ${isSecurityMonitoring ? "mb-2" : ""}`}
            >
              {control.label}
            </div>
            <Form.Group>
              <Form.Control
                type="time"
                placeholder={control.placeholder}
                name={name}
                onChange={(event) => {
                  handleChange(event);
                }}
                value={value}
                required={control.required ?? false}
                readOnly={control.readOnly ?? false}
                disabled={control.disabled ?? false}
                isValid={touched[control.name] && !errors[control.name]}
                isInvalid={
                  (!!touched[control.name] && !!errors[control.name]) ?? false
                }
              />
              {/* <h1>error</h1> */}
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );

    case "select":
      return (
        <>
          {control?.hideVisibility ? null : (
            <div className="flex items-start  w-100">
              <div className="w-100">
                <div className="filter-label mb-2">{control.label}</div>

                <Form.Group>
                  <div className="d-flex align-items-center">
                    <Form.Select
                      name={name}
                      onChange={(event) => {
                        handleChange(event);
                        if (control.onChange) {
                          control.onChange(event.target.value);
                        }
                      }}
                      value={value}
                      required={control.required ?? false}
                      disabled={control.disabled ?? false}
                      isValid={touched[control.name] && !errors[control.name]}
                      isInvalid={
                        (!!touched[control.name] && !!errors[control.name]) ??
                        false
                      }
                      style={{ height: "37.6px" }}
                    >
                      <option value={""}>{control.placeholder}</option>
                      {control.options?.map((option: any, index: number) => (
                        <option key={index + 0} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                    {control?.isLoading && (
                      <Spinner
                        animation="border"
                        variant="primary"
                        className="ms-1"
                        size="sm"
                      />
                    )}
                  </div>
                  <ErrorMessage
                    name={name}
                    component="div"
                    className="error-message"
                  />
                </Form.Group>
              </div>
            </div>
          )}
        </>
      );
    case "typeahead":
      return (
        <div className="flex items-start  w-100">
          <div className="w-100">
            <div className="filter-label">{control.label}</div>
            <Form.Group>
              <Typeahead
                multiple={control?.selectType === "multiple"}
                id="basic-typeahead"
                onChange={(selected) => {
                  let selectedValue: any = [];
                  let selectedLabel: any = [];

                  selected.forEach((option: any) => {
                    selectedLabel.push(option.label);
                    selectedValue.push(option.value);
                  });

                  setSelections(selectedLabel);
                  if (selectedValue.length) {
                    control?.selectType === "multiple"
                      ? setFieldValue(control.name, selectedValue)
                      : setFieldValue(control.name, selectedValue[0]);
                  }
                }}
                onInputChange={(text, event) => {
                  if (control.onInputChange) {
                    control.onInputChange(text);
                  }
                }}
                options={control?.selectOptions ? control?.selectOptions : []}
                placeholder={control?.placeholder}
                selected={selections}
                ref={typeaheadRef}
                disabled={control?.disabled}
              />
              <ErrorMessage
                name={name}
                component="div"
                className="error-message"
              />
            </Form.Group>
          </div>
        </div>
      );

    default:
      return null;
  }
};
